import { render } from "./ActionList.vue?vue&type=template&id=636555cc"
import script from "./ActionList.vue?vue&type=script&lang=ts"
export * from "./ActionList.vue?vue&type=script&lang=ts"
script.render = render

export default script